import { LogIn, UserCog, UserPlus, Pencil, Trash2 } from "lucide-react";

export function SchoolCard({ s, onImpersonate, onCoordEdit, onEdit, onRemove }) {
  const staffMode = s.mode === "staff";
  const sid = s.school.id.slice(0, 8);
  return (
    <div data-testid={`school-card-${sid}`} className="bg-surface rounded-2xl border border-brd shadow-md p-5">
      <div className="flex items-start justify-between gap-2 mb-1">
        <div className="font-head font-bold text-[15px] flex-1">{s.school.name}</div>
        <span className="text-[10px] font-bold bg-beige-600 dark:bg-surface2 rounded-full px-2.5 py-1 shrink-0">{s.school.gender || "—"}</span>
      </div>
      <div className="text-[11px] text-mutext mb-3 space-y-0.5">
        <div>{s.school.stage || "ثانوية"}{s.school.sector ? ` · القطاع: ${s.school.sector}` : ""} · {s.coordinator?.name || "لا يوجد منسق"} · السلطة: <b className="text-turq-600">{s.school.authority || "حكومي"}</b>
          {staffMode ? ` · المنسوبون: ${s.staff_count || 0}` : ` · الطلاب: ${s.total_students}`}</div>
        {(s.school.principal_name || s.school.address) && (
          <div>{s.school.principal_name ? `المدير: ${s.school.principal_name}` : ""}{s.school.principal_name && s.school.address ? " · " : ""}{s.school.address || ""}</div>
        )}
      </div>
      <div className="grid grid-cols-3 gap-2 mb-3">
        <div className="rounded-xl bg-beige-300 dark:bg-surface2 p-2.5 text-center">
          <div className="font-head font-black text-base">{s.opportunities}</div>
          <div className="text-[10px] text-mutext">فرصة</div>
        </div>
        <div className="rounded-xl bg-beige-300 dark:bg-surface2 p-2.5 text-center">
          <div className="font-head font-black text-base">{s.unique_students}</div>
          <div className="text-[10px] text-mutext">{staffMode ? "منسوب متطوع" : "متطوع"}</div>
        </div>
        <div className="rounded-xl bg-beige-300 dark:bg-surface2 p-2.5 text-center">
          <div className="font-head font-black text-base">{s.total_hours}</div>
          <div className="text-[10px] text-mutext">ساعة</div>
        </div>
      </div>
      {staffMode ? (
        <div className="flex items-end justify-between mb-4">
          <span className="text-[11px] text-mutext">{s.unique_students} منسوب مشارك من {s.staff_count || 0} · <b data-testid={`school-score-${sid}`} className="text-coral-600">{s.impact_score} نقطة أثر</b></span>
          <span className="font-head font-black text-xl text-turq-600">{s.total_hours} س</span>
        </div>
      ) : (
        <>
          <div className="flex items-end justify-between mb-1.5">
            <span className="text-[11px] text-mutext">{s.unique_students} فريد من {s.total_students} · <b data-testid={`school-score-${sid}`} className="text-coral-600">{s.impact_score} نقطة أثر</b></span>
            <span className={`font-head font-black text-xl ${(s.pct || 0) >= 90 ? "text-turq-600" : "text-coral-600"}`}>{s.pct ?? 0}%</span>
          </div>
          <div className="h-2 rounded-full bg-surface2 overflow-hidden mb-4">
            <div className="h-full rounded-full transition-all duration-700"
              style={{ width: `${Math.min(100, s.pct || 0)}%`, background: (s.pct || 0) >= 90 ? "#12939E" : "#FF7A59" }} />
          </div>
        </>
      )}
      <div className="flex gap-2">
        <button data-testid={`school-impersonate-${sid}`} onClick={() => onImpersonate(s)}
          className="flex-1 rounded-xl bg-turq-600 hover:bg-turq-900 text-white text-[11px] font-bold py-2.5 flex items-center justify-center gap-1.5 transition-colors">
          <LogIn className="w-3.5 h-3.5" /> الدخول كمنسق المدرسة
        </button>
        <button data-testid={`school-edit-${sid}`} onClick={() => onEdit(s)} title="تعديل بيانات المدرسة"
          className="w-10 rounded-xl bg-beige-600 dark:bg-surface2 flex items-center justify-center hover:scale-105 transition-transform">
          <Pencil className="w-3.5 h-3.5 text-turq-900 dark:text-turq-300" />
        </button>
        <button data-testid={`school-delete-${sid}`} onClick={() => onRemove(s)}
          className="w-10 rounded-xl bg-coral-100 dark:bg-surface2 flex items-center justify-center hover:scale-105 transition-transform">
          <Trash2 className="w-3.5 h-3.5 text-coral-900 dark:text-coral-300" />
        </button>
      </div>
      <button data-testid={s.coordinator ? `school-coord-edit-${sid}` : `school-coord-assign-${sid}`} onClick={() => onCoordEdit(s)}
        className={`mt-2 w-full rounded-xl text-[11px] font-bold py-2.5 flex items-center justify-center gap-1.5 transition-colors ${s.coordinator
          ? "bg-turq-100 dark:bg-surface2 text-turq-900 dark:text-turq-300 hover:bg-turq-300/60 dark:hover:bg-brd"
          : "bg-coral-600 text-white hover:bg-coral-900"}`}>
        {s.coordinator ? <UserCog className="w-3.5 h-3.5" /> : <UserPlus className="w-3.5 h-3.5" />}
        {s.coordinator ? "تعديل بيانات المنسق" : "تعيين منسق للمدرسة"}
      </button>
    </div>
  );
}
